module.exports = __webpack_public_path__ + "img/contact.e35f6ba9.png";